<template>
  <v-container>
    <List />
  </v-container>
</template>

<script>
import List from '@/components/List'

export default {
  name: 'Home',
  components: {
    List
  }
}
</script>
